import axios from "axios";

export const state = {
    librarybooks: [],
};

export const getters = {
    librarybooks: state => state.librarybooks,
};

export const mutations = {
    setLibraryBooks(state, newValue) {
        state.librarybooks = newValue
    },
};

export const actions = {
    fetchLibraryBooks({ commit }) {
        axios.get('/librarybooks').then(res => {
            commit('setLibraryBooks', res.data.librarybooks)
        })
    },
};
